const userAgentParser = () => {
  const userAgent = navigator.userAgent
  let parsedUserAgent = {}
  const isMobile = userAgent.includes('Mobile')
  if (userAgent.includes('iPhone')) {
    parsedUserAgent.device = 'ios_iphone'
  } else if (userAgent.includes('iPad')) {
    parsedUserAgent.device = 'ipad'
  } else if (userAgent.includes('Android') && isMobile) {
    parsedUserAgent.device = 'android_phone'
  } else if (userAgent.includes('Android') && !isMobile) {
    parsedUserAgent.device = 'android_tablet'
  } else if (isMobile) {
    parsedUserAgent.device = 'web_phone'
  } else if (!isMobile && window.width < 500) {
    parsedUserAgent.device = 'web_tablet'
  } else {
    parsedUserAgent.device = 'web_desktop'
  }
  return parsedUserAgent
}

export default userAgentParser
